/**
 * Bietet eine API für Settings (Config- und Modellwerte). Wird als neuer Prototype zum Literal Objekt Settings
 * hinzugefügt.
 */
import Maths from "oc-commons/Maths";

export default class SettingsMixin {

    getValue(key, def = '') {
        if (this[key] !== undefined && this[key].Wert !== undefined) {
            return this[key].Wert;
        } else {
            return def;
        }
    }

    getInt(key, def = 0) {
        if (this[key] !== undefined && this[key].Wert !== undefined) {
            let value = this.getValue(key);
            if (value.startsWith('#')) {
                value = parseInt(value.substring(1), 16)
            } else if (value.startsWith('0x')) {
                value = parseInt(value.substring(2), 16)
            } else {
                value = parseInt(value, 10);
            }
            return value;
        } else {
            return def;
        }
    }

    getFloat(key, def = 0) {
        return this._float(key, 'Wert', def);
    }

    getMinValue(key, def = 0) {
        return this._float(key, 'Minimal', def);
    }

    getMaxValue(key, def = 0) {
        return this._float(key, 'Maximal', def);
    }

    _float(key, subKey, def) {
        if (this[key] === undefined || this[key][subKey] === undefined) {
            return def;
        }
        const v = parseFloat(this[key][subKey]);
        return isNaN(v) ? def : v;
    }

    isWithinMinMaxValue(key, def) {
        const min = this.getMinValue(key);
        const max = this.getMaxValue(key);
        return (def > min && def < max);
    }

    getBool(key, def = false) {
        const strValue = this.getValue(key).toLowerCase();
        if (this[key] !== undefined) {
            return (strValue === 'true' || strValue === 'ja' || (this[key].JaNein !== undefined && this[key].JaNein === 'true'))
        } else {
            return def;
        }
    }

    cutBetween(wert, name) {
        return Maths.cutBetween(this.getMinValue(name), wert, this.getMaxValue(name));
    }

}
